import React, { useEffect, useState } from 'react';
import {
  Box, Fade, Modal, Table, TableContainer,
} from '@mui/material';
import ReactJson from 'react-json-view';
import { watchCollection } from '../../api/document-api/DocumentAPI';
import { CenteredCircularProgress } from '../../helper';
import TableHeader from '../table-header/TableHeader';
import JobRow from '../job-row/JobRow';
import { getComparator } from '../../api/status-api/StatusAPI';
import { Data } from '../../api/types/JobStatusTypes';

const style = {
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 6,
};

function JobModal({
  jobId, open, handleClose,
}: { jobId: string, open: boolean, handleClose: () => void, }) {
  const [loading, setLoading] = useState(true);
  const [jobStatuses, setJobStatuses] = useState<Data[]>([]);

  const [openJson, setOpenJson] = useState<{ [key:string] : boolean }>({});

  const handleJson = (openJobId: string, enable: boolean, index: number) => {
    const updatedOpenJson = { ...openJson };
    updatedOpenJson[`${openJobId}${index}`] = enable;
    setOpenJson(updatedOpenJson);
  };

  useEffect(() => {
    if (open) {
      const unsubscribe = watchCollection(setLoading, setJobStatuses, `jobStatus/${jobId}/status`);
      return () => unsubscribe();
    }
    return () => {};
  }, [open]);

  return (
    <Modal
      className="flex flex-col justify-center items-center"
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box className="w-3/4 h-3/4" sx={style}>
          { loading && <CenteredCircularProgress />}
          { !loading && (
          <TableContainer className="h-full" sx={{ height: '60vh' }}>
            <Table>
              <TableHeader onRequestSort={() => {}} order="desc" orderBy="timestamp" />
              {jobStatuses.sort(getComparator('desc', 'timestamp'))
                .map((job: Data, index: number) => (
                  <>
                    <Modal
                      aria-labelledby="json-modal-title"
                      aria-describedby="json-modal-description"
                      open={openJson[`${job.jobId}${index}`]}
                      onClose={() => handleJson(job.jobId, false, index)}
                      closeAfterTransition
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Box sx={style}>
                        <ReactJson src={job.metadata} />
                      </Box>
                    </Modal>
                    <JobRow row={job} handleOpen={() => handleJson(job.jobId, true, index)} />
                  </>
                ))}
            </Table>
          </TableContainer>
          )}
        </Box>
      </Fade>
    </Modal>

  );
}

export default JobModal;
